<template>
  <v-container fluid>
    <v-card class="mx-auto mt-5" outlined tile>
      <v-toolbar flat>
        <v-select
          label="Search by"
          v-model="searchArg"
          :items="searchArgs"
          hide-details
          single-line
          clearable
          class="mr-2"
        />
        <v-text-field
          v-show="searchArg !== 'memberType'"
          label="Search"
          type="text"
          prepend-icon="search"
          v-model="search"
          clearable
          hide-details
          single-line
        />
        <v-select
          v-show="searchArg === 'memberType'"
          label="Member Type"
          v-model="search"
          :items="ausMeatMemberTypeItems"
          clearable
          hide-details
          single-line
        />
      </v-toolbar>
    </v-card>
    <v-data-table
      dense
      disable-filtering
      disable-sort
      :headers="this.headers"
      :options.sync="options"
      :footer-props="footerProps"
      :server-items-length="this.list.count"
      :items="this.list.items"
      :loading="$apollo.queries.list.loading"
      item-key="companyID"
    >
      <template v-slot:item="{ item }">
        <tr>
          <td>{{ item.companyID }}</td>
          <td nowrap>{{ formatAbn(item.abn) }}</td>
          <td>{{ item.companyName }}</td>
          <td>{{ item.tradingName }}</td>
          <td>{{ item.memberType }}</td>
          <td>{{ item.accreditationCategory }}</td>
          <td>{{ item.dateAuditDue | formatDate }}</td>
          <td>{{ item.nextScheduledAuditor }}</td>
          <td>{{ item.givenName }}</td>
          <td>{{ item.surname }}</td>
          <td nowrap>{{ item.phone }}</td>
          <td nowrap>{{ item.fax }}</td>
          <td nowrap>{{ item.mobile }}</td>
          <td nowrap>{{ item.email }}</td>
          <td class="text-end">
            <v-btn small icon @click="details(item)">
              <v-icon color="primary">info</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>

      <template v-slot:footer.prepend>
        <v-btn
          text
          color="primary"
          :loading="!!csvStatus"
          :disabled="!!csvStatus || $apollo.queries.list.loading"
          @click="writeCsv"
        >
          <v-icon>save</v-icon>
          CSV
        </v-btn>
        {{ csvStatus }}
      </template>
    </v-data-table>

    <v-dialog
      v-model="dialog"
      max-width="800"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          {{ selectedItem.companyName }}
        </v-card-title>

        <v-card-text>
          <v-simple-table>
            <template v-slot:default>
              <tbody>
                <tr>
                  <th>
                    Postal Address
                  </th>
                  <td>
                    {{ selectedItem.postalAddress }}
                    {{ selectedItem.postalAddress2 }}
                    {{ selectedItem.postalTown }}
                    {{ selectedItem.postalPostcode }}
                    {{ selectedItem.postalState }}
                    {{ selectedItem.postalCountry }}
                  </td>
                </tr>
                <tr>
                  <th>
                    Address
                  </th>
                  <td>
                    {{ selectedItem.locationAddress }}
                    {{ selectedItem.locationAddress2 }}
                    {{ selectedItem.locationTown }}
                    {{ selectedItem.locationPostcode }}
                    {{ selectedItem.locationState }}
                    {{ selectedItem.locationCountry }}
                  </td>
                </tr>
                <tr
                  v-for="info in selectedItem.extraInfo"
                  :key="info.propertyName"
                >
                  <th>{{ info.propertyName }}</th>
                  <td>{{ info.propertyValue }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="primary"
            text
            @click="dialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import gql from 'graphql-tag'
import papa from 'papaparse'
import flatten from 'flat'
import download from 'downloadjs'
import { snakeCase } from 'change-case'

import abrMixin from '../mixins/abr-mixin'

export default {
  name: 'AdminAusMeatCompanyView',

  mixins: [
    abrMixin
  ],

  props: {
    abn: {
      type: String
    }
  },

  data () {
    return {
      headers: [
        { text: 'AUS-MEAT Company ID', value: 'companyID' },
        { text: 'ABN', value: 'abn' },
        { text: 'Company Name', value: 'companyName' },
        { text: 'Trading Name', value: 'tradingName' },
        { text: 'Member Type', value: 'memberType' },
        { text: 'Accreditation Category', value: 'accreditationCategory' },
        { text: 'Next Audit', value: 'dateAuditDue' },
        { text: 'Auditor', value: 'nextScheduledAuditor' },
        { text: 'Given Name', value: 'givenName' },
        { text: 'Surname', value: 'surname' },
        { text: 'Phone', value: 'phone' },
        { text: 'Fax', value: 'fax' },
        { text: 'Mobile', value: 'mobile' },
        { text: 'Email', value: 'email' },
        { text: 'Actions', class: 'text-end' }
      ],
      options: {
        page: 1,
        itemsPerPage: 10
      },
      footerProps: {
        'items-per-page-options': [10, 25, 50, 100, 200, 500]
      },
      list: {
        count: 0,
        items: []
      },
      selectedItem: {
        extraInfo: []
      },
      dialog: false,
      search: this.abn ? this.abn : null,
      searchArg: this.abn ? 'abn' : null,
      searchArgs: [
        { text: 'Establishment Number', value: 'establishmentNumber' },
        { text: 'ABN', value: 'abn' },
        { text: 'AUS-MEAT Company ID', value: 'companyID' },
        { text: 'Company Name', value: 'companyName' },
        { text: 'Contact Name', value: 'contactName' },
        { text: 'Accreditation Category', value: 'accreditationCategory' },
        { text: 'Member Type', value: 'memberType' }
      ],
      ausMeatMemberTypeItems: ['Plant', 'Supermarket', 'Retailer', 'Saleyard', 'Food Service', 'Wholesaler', 'Independent Boning Room'],
      csvStatus: null
    }
  },

  computed: {
    filter () {
      return {
        ...((this.searchArg && this.search) && {
          [this.searchArg]: this.search
        })
      }
    }
  },

  watch: {
    searchArg (_, oldVal) {
      if (oldVal) this.search = null
    }
  },

  apollo: {
    list: {
      query: gql`query SearchAusMeatCompanies ($filter: FilterFindManyAusMeatCompanyInput, $page: Int!, $perPage: Int!) {
        list: ausMeatCompanyManyPagination(filter: $filter, page: $page, perPage: $perPage) {
          count
          items {
            companyID
            companyName
            tradingName
            accreditationCategory
            memberType
            givenName
            surname
            dateAuditDue
            nextScheduledAuditor
            phone
            fax
            mobile
            email
            abn
            locationAddress
            locationAddress2
            locationTown
            locationState
            locationPostcode
            locationCountry
            postalAddress
            postalAddress2
            postalTown
            postalState
            postalPostcode
            postalCountry
            extraInfo {
              propertyName
              propertyValue
            }
          }
        }
      }`,
      variables () {
        return {
          filter: this.filter,
          page: this.options.page,
          perPage: this.options.itemsPerPage
        }
      },
      error (e) { this.onError(e) },
      debounce: 1000 // AUS-MEAT API is slow
    }
  },

  methods: {
    onError (e) {
      this.$emit('error', e)
    },

    details (item) {
      this.selectedItem = item
      this.dialog = true
    },

    async writeCsv () {
      this.csvStatus = 'Starting CSV download...'

      const pages = []
      const variables = {
        filter: this.filter,
        page: 1,
        perPage: 500
      }
      const maxPage = Math.floor(this.list.count / variables.perPage) + 1
      while (variables.page <= maxPage) {
        this.csvStatus = `Fetching page ${variables.page} of ${maxPage}... This might take a while.`
        await this.$apollo.queries.list.fetchMore({
          variables,
          updateQuery (_, { fetchMoreResult }) {
            pages.push(fetchMoreResult.list.items)
          }
        })
        variables.page++
      }
      this.csvStatus = 'Generating CSV...'

      const flatItems = pages.flat()
        // Turn extraInfo into a K:V object to make CSV tidier
        .map(o => ({
          ...o,
          extraInfo: Object.fromEntries(o.extraInfo.map(o => [o.propertyName, o.propertyValue]))
        }))
        // Flatten objects into dot notation keys for nested values
        .map(o => flatten(o))

      // Write CSV
      const csv = papa.unparse(flatItems)

      // Construct filename
      const now = new Date()
      let fileName = 'mymsa_ausmeat_companies'
      if (this.searchArg && this.search) fileName += `_${snakeCase(this.searchArg)}_${snakeCase(this.search)}`
      fileName += `_${now.toISOString()}.csv`

      // Download CSV
      download(csv, fileName, 'text/csv')
      this.$emit('info', `File downloading as ${fileName}`)
      this.csvStatus = null
    }
  }
}
</script>
